import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const {
  endpoints: {
    operators: { user: url },
  },
} = config

/**
 * Obtain user related info.
 *
 * @param {Object} params No params, just in case
 */
export default (authToken) => axios.get(url, { headers: { ...getHeaders(), 'nx-auth-token': authToken } })
